import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import { getPlans, getUsers, getSessions } from '../../data/mockData';
import Tabs from '../../components/shared/Tabs';
import FloatingActionButton from '../../components/shared/FloatingActionButton';
import AllPlansTab from '../../components/schedule/AllPlansTab';
import SessionsTab from '../../components/schedule/SessionsTab';
import BookingCalendarTab from '../../components/schedule/BookingCalendarTab';
import AssignPlanModal from '../../components/plans/AssignPlanModal';
import BookSessionModal from '../../components/schedule/BookSessionModal';
import CancelSessionModal from '../../components/schedule/CancelSessionModal';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';
import useDidFetch from '../../custom_hooks/useDidfetch';

const PlanSessionManagementPage = () => {
    const [plans, setPlans] = useState([]);
    const [users, setUsers] = useState([]);
    const [trainers, setTrainers] = useState([]);
    const [sessions, setSessions] = useState([]);

    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isBookModalOpen, setIsBookModalOpen] = useState(false);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [isCancelLoading, setIsCancelLoading] = useState(false);
    const [isSaveLoading, setIsSaveLoading] = useState(false);

    const [activePlan, setActivePlan] = useState(null);
    const [activeSession, setActiveSession] = useState(null);

    const handleOpenAssignModal = (plan) => {
        setActivePlan(plan);
        setIsAssignModalOpen(true);
    };
    

    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getAllPlans();
            getAllUser();
            getAllSessions();
            getTrainers()
        });
    }, []);

    const handleOpenBookModal = () => {
        setIsBookModalOpen(true);
    };

    const handleOpenCancelModal = (session) => {
        setActiveSession(session);
        setIsCancelModalOpen(true);
    };

    const handleSaveAssignment = async (assignmentData) => {
        console.log("Assignment Data:", assignmentData);
        let obj = {
            "user_id": assignmentData?.userId,
            "plan_id": assignmentData?.planId,
            "start_date": assignmentData?.startDate,
            "end_date": assignmentData?.endDate,
            "notes": assignmentData?.notes,
        }

        try {
            const response = await api.post(ENDPOINTS.assignPlan, obj);
            const result = response?.data;
            if (response.status === 200 || response.status === 201) {
                toast.success(`Plan "${assignmentData.planName}" assigned to ${assignmentData.memberName}.`);
            }
        } catch (error) {
            console.log("assign plan error", error);
        } finally {
            setIsAssignModalOpen(false);
            setActivePlan(null);
        }

    };

    const handleSaveBooking = async (bookingData) => {
        console.log(`handlesavebooking ${bookingData}`);

        try {
            setIsSaveLoading(true);
            const response = await api.post(ENDPOINTS.newBookingApi, bookingData);
            const result = response?.data;
            console.log(response);
            if (response.status === 200 || response.status === 201) {
                toast.success('Session booked successfully.');
                setIsBookModalOpen(false);
                getAllSessions();
            }
        } catch (error) {
            console.error("Session booked:", error); 
        } finally {
            setIsSaveLoading(false);
        }

    };

    const handleConfirmCancel = async (session) => {
        try {
            setIsCancelLoading(true);
            let response = await api.put(`${ENDPOINTS.cancelBookingApi}/${session.id}`);
            console.log(response);
            if (response?.status == 200 || response?.status == 201) {
                toast.success('Session has been cancelled.');
                setIsCancelModalOpen(false);
                setActiveSession(null);
                getAllSessions();
            }
        } catch (error) {
            console.log("cancelerror", error);
        } finally {
            setIsCancelLoading(false);
        }
    };

    const getAllPlans = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getPlan);
            const result = response?.data;
            console.log(response);
            if (response.status === 200 || response.status === 201) {
                setPlans(result ?? []);
            }
        } catch (error) {
            console.error("plans get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const getAllSessions = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getAllSessionsApi);
            const result = response?.data;
            console.log(result);
            if (response.status === 200 || response.status === 201) {
                setSessions(result ?? []);
            }
        } catch (error) {
            console.error("setSessions get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const getAllUser = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getUser);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setUsers(result?.users ?? []);
            } else {
                toast.error(result?.message || "Login failed!");
            }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
     const getTrainers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/trainer`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setTrainers(result?.users ?? []);
            }
        } catch (error) {
            console.error("getMembers error:", error);
        } finally {
            // setIsLoading(false);
        }
    }

    const activeSessions = sessions.filter(s => s.status === 'scheduled');
    const cancelledSessions = sessions.filter(s => s.status === 'cancelled');

    const tabs = [
        // { label: 'All Plans', content: <AllPlansTab plans={plans} onAssign={handleOpenAssignModal} /> },
        { label: 'All Sessions', content: <SessionsTab sessions={sessions} onCancel={handleOpenCancelModal} /> },
        { label: 'Active Sessions', content: <SessionsTab sessions={activeSessions} onCancel={handleOpenCancelModal} /> },
        { label: 'Cancelled Sessions', content: <SessionsTab sessions={cancelledSessions} /> },
        // { label: 'Booking Calendar', content: <BookingCalendarTab sessions={sessions ?? {}} /> },
    ];
    return (
        <>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="space-y-6"
            >
                <h1 className="text-3xl font-bold font-display text-gray-800">Session Management</h1>
                <Tabs tabs={tabs} />

                <FloatingActionButton onClick={handleOpenBookModal}>
                    <Plus size={24} />
                </FloatingActionButton>
            </motion.div>

            <AssignPlanModal
                isOpen={isAssignModalOpen}
                onClose={() => setIsAssignModalOpen(false)}
                onAssign={handleSaveAssignment}
                plan={activePlan}
                users={users.filter(u => u.role?.name === 'member')}
                plans={plans}
            />

            <BookSessionModal
                isOpen={isBookModalOpen}
                onClose={() => setIsBookModalOpen(false)}
                onSave={handleSaveBooking}
                members={users.filter(u => u.role?.name === 'member')}
                trainers={trainers}
                isLoading={isSaveLoading}
            />

            <CancelSessionModal
                isLoading={isCancelLoading}
                isOpen={isCancelModalOpen}
                onClose={() => setIsCancelModalOpen(false)}
                onConfirm={handleConfirmCancel}
                session={activeSession}
            />
        </>
    );
};

export default PlanSessionManagementPage;
